import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RoutingComponent } from './component/routing.component';
import { MaterialModule, ServiceResponseModule } from '@sdbn/appclient';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { TransportInfoPanelModule } from '@sdbn/appclient';
import { CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { RoutingPositionEditorComponent } from './component/routing-position-editor/routing-position-editor.component';

@NgModule({
  declarations: [RoutingComponent, RoutingPositionEditorComponent],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    MatInputModule,
    ReactiveFormsModule,
    TransportInfoPanelModule,
    CommonTranslationModule,
    ApplicationClientCommonModule,
    ServiceResponseModule,
    CommonUIModule
  ],
  exports: []
})
export class TransportRoutingModule { }
